export enum ClientListSortBy {
    None = 0,
    NameAsc = 1,
    NameDesc = 2,
    EmailAsc = 5,
    EmailDesc = 6,
    PhoneAsc = 7,
    PhoneDesc = 8,
    NumAsc = 9,
    NumDesc = 10,
    StatusAsc = 11,
    StatusDesc = 12,
  }